import moment from 'moment'

export default {
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    textDescriptionOfStructure: function (wo) {
      let ind = '    '
      let struct = wo.structure.struct
      let total = wo.structure.volume.total

      let text = 'Lot Structure\n'
      text += ind + 'Vintage\n'
      Object.keys(struct.vintage).forEach(function (key) {
        text += ind+ind + key + ': ' + (struct.vintage[key]/total * 100).toFixed(1) + '%\n'
      })
      text += ind + 'Appellation\n'
      Object.keys(struct.appellation).forEach(function (key) {
        text += ind+ind + key + ': ' + (struct.appellation[key]/total * 100).toFixed(1) + '%\n'
      })
      text += ind + 'Vineyard\n'
      Object.keys(struct.vineyard).forEach(function (key) {
        text += ind+ind + key + ': ' + (struct.vineyard[key]/total * 100).toFixed(1) + '%\n'
      })
      text += ind + 'Varietal\n'
      Object.keys(struct.varietal).forEach(function (key) {
        text += ind+ind + key + ': ' + (struct.varietal[key]/total * 100).toFixed(1) + '%\n'
      })
      return text
    },
    isStaff: function () {
      if (this.$store.state.user) {
        return this.$store.state.user.staff === 'YES'
      }
      return false
    },
    hasPermission: function (clientCode) {
      if (this.isStaff() === true) return true
      for (var i=0; i<this.$store.state.clients.length; i++) {
        let client = this.$store.state.clients[i]
        if (clientCode === client.CODE) {
          return true
        }
      }
      return false
    },
    roundTons: function (value) {
      return Math.round(value * 100) / 100
    },
    prettyDate: function (date) {
      return moment.utc(date).format(this.$store.state.momentDateFormat)
    },
    getIcon: function (woType) {
      switch (woType) {
        case 'BOL': return 'fa-clipboard-list'
        case 'WT': return 'fa-balance-scale'
        case 'PRESSOFF': return 'fa-fill-drip'
        case 'BOTTLING': return 'fa-wine-bottle'
        case 'BLENDING': return 'fa-exchange-alt'
        case 'SCP': return 'fa-truck-loading'
        case 'LAB TEST': return 'fa-mortar-pestle'
      }
      return 'fa-hammer'
    },
    getColor: function (woType) {
      return 'blue-grey'
      // switch (woType) {
      //   case 'BOL': return 'brown'
      //   case 'WT': return 'orange'
      //   case 'PRESSOFF': return 'red'
      //   case 'BOTTLING': return 'lime'
      //   case 'BLENDING': return 'yellow'
      //   case 'SCP': return 'green'
      //   case 'LAB TEST': return 'blue-grey'
      // }
      // return 'primary'
    },
    getTheme: function (woType) {
      switch (woType) {
        case 'BOL': return true
        case 'WT': return true
        case 'PRESSOFF': return true
        case 'BOTTLING': return false
        case 'BLENDING': return false
        case 'SCP': return true
        case 'LAB TEST': return true
      }
      return true
    }

  },
  computed: {
    tankPosition () {
      return ['TOP', 'BOTTOM']
    },
    crushing () {
      return ['COMPLETE', 'PARTIAL', 'NOCRUSHING']
    },
    yesNo () {
      return ['YES', 'NO', 'DIRECTTOPRESS']
    },
    lots () {
      return this.$store.state.llotsForVintageots
    },
    clients () {
      return this.$store.state.clients
    },
    client () {
      return this.$store.state.client
    }
  }
}
